export default __webpack_public_path__ + "media/images/mailer-new/welcome/feature_creativity-c6a1266c4d288e9428ae14aa41eaddee.png";